<template>
    <div>
        <div class="bohemia-header-wrapper">
            <slot :onClick="toggleDropdown" :onMouseEnter="showDropdown" :onMouseLeave="hideDropdown" :open="open"></slot>
        </div>
        <div class="bohemia-header-dropdown-menu"
             :class="{open : open, right : placement === 'right', left : placement === 'left'}">
            <ul class="bohemia-header-nav-items">
                <li class="bohemia-header-nav-item" v-for="item in items" data-active="false">
                    <template v-if="item === 'separator'">
                        <separator/>
                    </template>
                    <template v-else>
                        <a class="bohemia-header-nav-item-button" :href="item.href"
                           :data-parent-id="parent"><span>{{item.name}}</span></a>
                    </template>

                </li>
                <slot name="items"></slot>
            </ul>
        </div>
    </div>
</template>

<script>
    import isMobile from 'ismobilejs';
    import Separator from './../../partials/Separator';

    export default {
        name      : 'bohemia-dropdown',
        components: {Separator},
        props     : {
            id       : [Number, String],
            placement: {
                type   : String,
                default: 'left'
            },
            items    : [Object, Array],
            parent   : Number,
            openItem : {}
        },
        data      : function() {
            return {
                open: false
            }
        },
        methods   : {
            toggleDropdown() {
                this.open = !this.open;
                this.$emit('onOpen', this.id);
            },
            showDropdown() {
                if (!this.open) {
                    this.open = true;
                    this.$emit('onOpen', this.id);
                }
            },
            hideDropdown() {
                if (this.open) {
                    this.open = false;
                    this.$emit('onOpen', this.id);
                }
            }
        },
        mounted() {
            // if not mobile, add ability toggle dropdown on hover
            if (window.innerWidth > 900 && !isMobile.any) {
                this.$el.addEventListener('mouseenter', this.showDropdown);
                this.$el.addEventListener('mouseleave', this.hideDropdown);
            }
        },
        beforeDestroy() {
            this.$el.removeEventListener('mouseenter', this.showDropdown);
            this.$el.removeEventListener('mouseleave', this.hideDropdown);
        },
        watch     : {
            openItem(val) {
                if (this.open && val !== this.id) {
                    this.open = false
                }
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import '/../../../assets/scss/header/colors';

    a {
        text-decoration: none;
    }

    .bohemia-header-dropdown-menu {
        @import '/../../../assets/scss/header/nav';

        border-top: 2px solid $colorHighlight;
        position: absolute;
        top: 100%;
        background: $bgOnHover;
        width: 100%;
        min-width: 250px;

        &.right {
            right: 0;
        }

        &.left {
            left: 0;
        }

        transform: translateY(1.5em);
        z-index: 1;
        transition: all 0.3s ease-in-out 0s, visibility 0s linear 0.3s, z-index 0s linear 0.01s;
        visibility: hidden; /* hides sub-menu */
        opacity: 0;

        > ul {
            > li {
                display: block !important;

                a {
                    text-align: left !important;
                    line-height: 4;
                    display: block;

                    &:hover {
                        background: $bg !important;
                    }
                }
            }
        }

        &.right {
            right: 0;

            > ul {
                > li {
                    a {
                        text-align: right !important;
                    }
                }
            }
        }

        &.open {
            visibility: visible; /* shows sub-menu */
            opacity: 1;
            transform: translateY(0%);
            transition-delay: 0s, 0s, 0.3s;
        }
    }
</style>
